import axios from "axios";

export const getNextExpediente = () => {
  return axios.get("/api/pacientes/next-expediente", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  }).then(r => r.data);
};

export const crearPaciente = (paciente) => {
  return axios.post("/api/pacientes", paciente, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  }).then(r => r.data);
};
